<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="CopyIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="copyLink"
      v-clipboard:copy="generateUrl(params.data.InvoiceSettingKey)"
      v-clipboard:success="onCopySuccess"
    />
    <feather-icon
      icon="EditIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      v-if="params.data.IsActive && !params.data.IsDeleted"
      icon="TrashIcon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="deleteRecord"
    />
    <feather-icon
      v-if="params.data.IsDeleted"
      icon="CheckIcon"
      svgClasses="h-5 w-5 hover:text-success cursor-pointer"
      @click="activateRecord"
    />
  </div>
</template>

<script>
export default {
  name: "CellRendererGroupActions",
  methods: {
    generateUrl(key) {
      return process.env.VUE_APP_APP_URL + "paymentgroup/" + key;
    },
    copyLink() {},
    onCopySuccess() {
      this.$vs.notify({
        title: "Başarılı",
        text: "Link kopyalandı.",
        color: "success",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-check-circle",
      });
    },
    editRecord() {
      // Emit to parent via context
      if (this.params.context && this.params.context.componentParent) {
        this.params.context.componentParent.editData(this.params.data);
      }
    },
    deleteRecord() {
      if (this.params.context && this.params.context.componentParent) {
        this.params.context.componentParent.deleteData(this.params.data.InvoiceSettingGroupID);
      }
    },
    activateRecord() {
      if (this.params.context && this.params.context.componentParent) {
        this.params.context.componentParent.activateData(this.params.data.InvoiceSettingGroupID);
      }
    },
  },
};
</script>
